// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"ed573816","85":"21077602","237":"21077602","323":"21077602","621":"1ea12c44"}[chunkId] + ".chunk.css";
};